export default function connectWebViewJavascriptBridge(callback) {
    if (window.WebViewJavascriptBridge) {
        callback(window.WebViewJavascriptBridge);
        return;
    }
    if (this.isAndroid) {
        document.addEventListener('WebViewJavascriptBridgeReady', () => {
            callback(window.WebViewJavascriptBridge);
        }, false);
    }
    else if (this.isIos) {
        if (window.WVJBCallbacks) {
            window.WVJBCallbacks.push(callback);
            return;
        }
        window.WVJBCallbacks = [callback];
        const WVJBIframe = document.createElement('iframe');
        WVJBIframe.style.display = 'none';
        WVJBIframe.src = 'wvjbscheme://__BRIDGE_LOADED__';
        document.documentElement.appendChild(WVJBIframe);
        setTimeout(() => {
            document.documentElement.removeChild(WVJBIframe);
        }, 0);
    }
}
// mounted() {
//     if (window.WebViewJavascriptBridge) {
//         window.WebViewJavascriptBridge.registerHandler('test', (data, responseCallback) => {
//             console.log(data);
//             responseCallback('responseData');
//         });
//         return;
//     }
//     document.addEventListener('WebViewJavascriptBridgeReady', () => {
//         console.log('WebViewJavascriptBridgeReady');
//         window.WebViewJavascriptBridge.registerHandler('test', (data, responseCallback) => {
//             console.log('test ------>');
//             console.log(data);
//             responseCallback('responseData');
//         });
//     }, false);
// },
